import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            communicationsReceived: 'communications/Communications',
            communicationReceived: 'communications/Communication',
            communicationDeliveryLogReceived: 'communications/CommunicationDeliveryLog',
            communicationAttachmentsReceived: 'communications/CommunicationAttachments',
        }),
    },
    methods: {
        ...mapActions({
            FetchCommunicationsByStudentID: 'communications/FetchCommunicationsByStudentID',
            FetchCommunication: 'communications/FetchCommunication',
            FetchCommunicationDeliveryLog: 'communications/FetchCommunicationDeliveryLog',
            FetchCommunicationAttachments: 'communications/FetchCommunicationAttachments',
        }),
        LoadCommunicationsByStudentID() {
            eventBus.$emit('communications-fetch:started');
            this.FetchCommunicationsByStudentID({ StudentID: this.student.StudentID })
                .then(() => {
                    this.communications = [...this.communicationsReceived];
                    eventBus.$emit('communications-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('communications-fetch:finished'));
        },
        ResetCommunication() {
            this.communication = {
                id: parseInt(this.$route.params.communicationId),
            };
        },
        LoadCommunication() {
            this.ResetCommunication();

            eventBus.$emit('communication-fetch:started');
            this.FetchCommunication({ ID: this.communication.id })
                .then(() => {
                    this.communication = Object.assign({}, this.communicationReceived);
                    eventBus.$emit('communication-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('communication-fetch:finished'));
        },
        LoadCommunicationDeliveryLog() {
            eventBus.$emit('communication-delivery-log-fetch:started');
            this.FetchCommunicationDeliveryLog({ ID: this.communication.id })
                .then(() => {
                    this.communicationDeliveryLogs = Object.assign([], this.communicationDeliveryLogReceived);
                    eventBus.$emit('communication-delivery-log-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('communication-delivery-log-fetch:finished'));
        },
        LoadCommunicationAttachments() {
            eventBus.$emit('communication-attachments-fetch:started');
            this.FetchCommunicationAttachments({ FKCommunicationID: this.communication.id })
                .then(() => {
                    this.communicationAttachments = [...this.communicationAttachmentsReceived];
                    eventBus.$emit('communication-attachments-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('communication-attachments-fetch:finished'));
        },
        DownloadCommunicationAttachment(id, name) {
            eventBus.$emit('communication-attachment-download:started');

            axios.post(`${process.env.BASE_URL}api/communications/communication/attachment/download`,
                { ID: id },
                {
                    headers: { Authorization: `Bearer ${sessionStorage.appToken}` },
                    responseType: 'blob',
                    onDownloadProgress(event) { eventBus.$emit('communication-attachment-download:progress', { event }); }
                })
                .then(response => {
                    if (!!response.data) {
                        const link = document.createElement('a');
                        const url = window.URL.createObjectURL(response.data);
                        link.href = url;
                        link.setAttribute('download', name);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                    }
                    eventBus.$emit('communication-attachment-download:success', event);
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('communication-attachment-download:finished'));
        },
        FormatParticipant(participant) { return !!participant?.Name ? `${participant?.Name} <${participant?.Address}>` : '...'; },
        GetCommunicationStatusColor(status) {
            switch (status) {
                case 'Failed to Send': return 'error';
                case 'Sending': return 'warning';
                case 'Sent': return 'success';
                default: return 'info';
            }
        }
    },
};